// Deleted agents and bots are never shown in CCP admin
export const withoutDeleted = (agents = []) => agents.filter((agent) => !agent.deleted)

export const withoutAgent = (agents = [], agentId) => agents.filter((agent) => agent.id !== agentId)

// Returns the warning shown before deleting an agent that still has conversations, otherwise null
export function deleteConversationsWarning(agent) {
  const count = agent?.conversationCount || 0
  if (count <= 0) {
    return null
  }
  return `${agent.name} still has ${count} ${count === 1 ? 'conversation. It' : 'conversations. They'} will be detached.`
}

// Lowers the agent's conversation count by one (never below 0) after a hard detach, without changing the original list
export const withConversationRemoved = (agents = [], agentId) => agents.map((agent) => (
  agent.id === agentId ? { ...agent, conversationCount: Math.max((agent.conversationCount || 0) - 1, 0) } : agent
))

// Removes the hard-detached conversation from the popup rows
export const withoutConversation = (conversations = [], conversationUid) => (
  conversations.filter((conversation) => conversation.conversationUid !== conversationUid)
)

export const HARD_DETACH_OUTCOME = {
  SUCCESS: 'success',
  NOT_ATTACHED: 'notAttached',
  FAILED: 'failed',
}

// Maps the API error of a hard detach to what the popup does next
export function hardDetachOutcome(error) {
  if (!error) {
    return HARD_DETACH_OUTCOME.SUCCESS
  }
  if (error.code === 'conversationNotAttached') {
    return HARD_DETACH_OUTCOME.NOT_ATTACHED
  }
  return HARD_DETACH_OUTCOME.FAILED
}

// Always plain text, never the API error object
export function hardDetachMessage(outcome, accountName) {
  if (outcome === HARD_DETACH_OUTCOME.SUCCESS) {
    return `Conversation hard-detached from ${accountName}`
  }
  if (outcome === HARD_DETACH_OUTCOME.NOT_ATTACHED) {
    return `This conversation was no longer attached to ${accountName}, so it wasn't hard-detached. It may have been moved to another agent or bot, or already detached.`
  }
  return 'Could not hard-detach the conversation. Please try again.'
}

// The not-attached message is longer, so it stays 10 seconds; the other toasts keep the default
export function hardDetachToastOptions(outcome) {
  return outcome === HARD_DETACH_OUTCOME.NOT_ATTACHED ? { autoClose: 10000 } : {}
}

// The conversations popup opens when it has rows to show, or a load error to show
export const isConversationsModalOpen = (conversations = [], error = null) => conversations.length > 0 || !!error
